import { baseColors } from './baseColors'
import { baseTheme } from './baseTheme'
import { ThemeType } from './theme.types'

export const platosferaTheme: ThemeType = {
  ...baseTheme,
  colors: {
    text: {
      accent: '#ea1f49',
      primary: baseColors.neutral_50,
      secondary: baseColors.neutral_400,
      tertiary: baseColors.neutral_500,
      inverted: baseColors.neutral_800,
      positive: baseColors.green_500,
      negative: baseColors.red_400,
      primaryLink: '#ea1f49',
      visitedLink: baseColors.violet_500,
      secondaryLink: baseColors.neutral_400,
      visitedSecondaryLink: baseColors.neutral_300,
      warning: baseColors.amber_300,
      disabled: baseColors.neutral_700,
    },

    background: {
      primary: baseColors.black_950,
      modal: baseColors.black_800,
      secondary: baseColors.black_800,
      inverted: baseColors.neutral_100,
      hover: baseColors.neutral_100_10,
      header: baseColors.black_900_75,
      disabled: baseColors.neutral_100_10,
      accent: '#ea1f49',
      accent_30: '#ea1f494D',
      tertiary: baseColors.black_700,
      elevated: baseColors.neutral_700,
      warning: baseColors.amber_300_30,
      positive: baseColors.green_500,
      gradientAccent: '#ea1f49',
      gradientSecondary: '#24040b',
    },

    icon: {
      primary: baseColors.neutral_50,
      secondary: baseColors.neutral_400,
      tertiary: baseColors.neutral_500,
      inverted: baseColors.neutral_800,
      accent: '#ea1f49',
      positive: baseColors.green_500,
      negative: baseColors.red_400,
      warning: baseColors.amber_300,
      disabled: baseColors.neutral_700,
    },

    badge: {
      sale: baseColors.lime_400,
      new: '#ea1f49',
      popular: baseColors.orange_500,
      waiting: baseColors.neutral_100,
      popular_20: baseColors.orange_500_30,
      official: baseColors.sky_500,
      official_20: baseColors.sky_500_30,
      sale_20: baseColors.lime_400_30,
      new_20: '#ea1f494D',
      negative: baseColors.red_500,
      negative_20: baseColors.red_500_20,
      positive: baseColors.green_500,
      positive_20: baseColors.green_500_20,
      warning: baseColors.amber_300,
      warning_20: baseColors.amber_300_20,
    },

    stroke: {
      default: baseColors.neutral_100_5,
      hover: baseColors.neutral_300_30,
      active: '#ea1f49',
      error: baseColors.red_400,
      alternativeActive: baseColors.neutral_50,
      positive: baseColors.green_300,
    },

    overlay: {
      primary: baseColors.black_1000_50,
      primary_65: baseColors.neutral_950_65,
    },

    toast: {
      success: {
        background: baseColors.green_500,
        icon: baseColors.green_700,
      },
      error: {
        background: baseColors.red_500,
        icon: baseColors.red_700,
      },
      warning: {
        background: baseColors.amber_500,
        icon: baseColors.amber_700,
      },
      info: {
        background: baseColors.blue_500,
        icon: baseColors.blue_700,
      },
    },

    constant: {
      white: baseColors.neutral_50,
      white_5: baseColors.neutral_100_5,
      white_10: baseColors.neutral_100_10,
      white_65: baseColors.neutral_100_65,
      black: baseColors.black_800,
      gray: baseColors.neutral_500,
    },
  },
}
